/** 非具体业务模块 */
import { alovaInstance } from '../index'

/** 登录API */
export function login(payload: any) {
  return alovaInstance.Post('/admin-api/system/auth/login', payload, {
    meta: { authRole: 'login' }
  })
}

/** 用户权限菜单列表 */
export const getUserMenuList = () => alovaInstance.Get('/admin-api/system/auth/get-permission-info')

/** 文件上传 */
export const fileUpload = (payload: any) => alovaInstance.Post('/admin-api/infra/file/upload', payload)

/** token刷新 */
export function refreshToken(payload: any) {
  return alovaInstance.Post('/admin-api/system/auth/refresh-token', payload, {
    meta: { authRole: 'refreshToken' }
  })
}
